<template>
  <v-container
    class="d-flex justify-center pa-0"
    style="background-color: white !important"
  >
    <v-row align="center" justify="center" v-if="showpaymenterror_msg">
      <v-col cols="12" md="12" justify-center>
        <div
          style="
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <p style="font-weight: bold">
            There are no payments due at this time.
            <br />
            <br />
          </p>
          <p style="text-align: center">
            <v-btn variant="elevated" color="primary" @click="redirecthome()"
              >OK</v-btn
            >
          </p>
        </div>
      </v-col>
    </v-row>

    <v-card
      style="
        width: 900px;
        margin-top: 10px;
        padding: 0px;
        border: 1px solid black;
      "
      class="d-flex flex-column align-center"
      v-if="showpaymenterror_msg"
    >
      <div>There are no payments due at this time.</div>
    </v-card>

    <v-card v-else>
      <v-row align="center" justify="center" v-if="loading">
        <v-col cols="12" md="12" justify-center>
          <v-overlay class="align-center justify-center">
            <v-progress-circular
              color="primary"
              indeterminate
              size="65"
            ></v-progress-circular>
          </v-overlay>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        v-if="$store.state.lock_value == '2' || $store.state.lock_value == '3'"
      >
        <v-col cols="12" md="12" sm="12" xs="12" justify-center>
          <div
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <p style="font-weight: bold">
              Account is locked for processing, please try again in 1-2 minutes.
              <br />
              <br />
            </p>
            <p style="text-align: center">
              <v-btn variant="elevated" color="primary" @click="redirecthome()"
                >OK</v-btn
              >
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row
        align="center"
        justify="center"
        class="pa-0 ma-0 justify-center"
        v-else
      >
        <!-- 6/11/2026 Ticket#PRG-1931 -->
        <v-col
          cols="12"
          md="8"
          xs="12"
          sm="12"
          v-if="$store.state.is_auto_ach_account == true"
        >
          <v-card
            style="padding: 0px; border: 1px solid #185fa5"
            class="py-5 bas-desc text-left"
            ><v-row>
              <v-col cols="auto" class="pa-5 pr-0">
                <v-icon>mdi-restore</v-icon>
              </v-col>
              <v-col>
                <div v-html="$store.state.autoachText"></div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8">
          <v-card
            style="margin: 5px; padding: 0px; border: 1px solid black"
            class=""
          >
            <div
              id="form-container"
              class="pdf-safe"
              style="background-color: white !important; margin: 1px"
            >
              <v-row class="pa-0 ma-0 text-center">
                <v-col
                  cols="12"
                  md="12"
                  xs="12"
                  sm="12"
                  class="pa-0 mt-5 font-weight-bold text-h6"
                >
                  Payments Due
                </v-col>

                <v-col cols="12" md="12" xs="12" sm="12" class="pa-0">
                  <div
                    align="center"
                    justify="center"
                    class="text-decoration-underline blue--text"
                  >
                    <span
                      @click="showDialog = true"
                      class="text-decoration-underline blue--text pointer-cursor pl-5"
                      >Instructions</span
                    >
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                  xs="12"
                  sm="12"
                  class="pa-0 font-weight-bold py-1"
                >
                  The U.S. Banking System suggests that ACH Payments may take
                  2-3 business days to process.

                  <div
                    v-if="
                      $store.state.autoachText_word1 != null &&
                      $store.state.autoachText_word1 != ''
                    "
                    class="mt-2"
                  >
                    <p style="color: red">
                      <strong>Recurring ACH Setup Sign up:</strong>
                      Select only one month from below to enroll. Your first ACH
                      payment will process within 2-3 business days of
                      completion. All subsequent recurring ACH payments will
                      occur on the due date specified in your coupons and
                      displayed on screen.
                    </p>
                  </div>
                </v-col>

                <v-col cols="12" md="12" xs="12" sm="12" class="pa-5">
                  <div class="table-scroll-both">
                    <v-data-table
                      :items="TABLEDATA"
                      :headers="headers"
                      class="pa-0 full-width-table"
                      density="compact"
                    >
                      <template #item="{ item: row, index }">
                        <tr
                          :class="{ 'locked-row': row.PENDING_ACH_PAY_REFID }"
                        >
                          <td
                            style="
                              padding: 0px 0px;
                              margin: 0px 0px;
                              text-align: center;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                gap: 0px;
                                margin: 0;
                                padding: 0;
                              "
                            >
                              <v-checkbox
                                v-model="row.SELECTED_FOR_PAYMENT"
                                :true-value="1"
                                :false-value="0"
                                @change="updateSelection(index)"
                                density="compact"
                                style="margin: 0; padding: 0"
                                color="primary"
                              />
                              <span
                                v-if="row.PENDING_ACH_PAY_REFID"
                                style="
                                  color: red;
                                  font-size: 12px;
                                  margin-top: 0px;
                                  padding-top: 0px;
                                "
                              >
                                Processing..
                              </span>
                            </div>
                          </td>
                          <td
                            style="
                              text-align: center;
                              vertical-align: middle;
                              padding: 0px 0px;
                              margin: 0px 0px;
                            "
                          >
                            {{ row.BILLING_PERIOD }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              vertical-align: middle;
                              padding: 0px 0px;
                              margin: 0px 0px;
                            "
                          >
                            {{ row.DUEDATE }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              vertical-align: middle;
                              padding: 0px 0px;
                              margin: 0px 0px;
                            "
                          >
                            ${{ row.AMOUNT_BILLED.toFixed(2) }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              vertical-align: middle;
                              padding: 0px 0px;
                              margin: 0px 0px;
                            "
                          >
                            ${{ row.PRIORPAID.toFixed(2) }}
                          </td>
                          <td
                            style="
                              text-align: center;
                              vertical-align: middle;
                              padding: 0px 0px;
                              margin: 0px 0px;
                            "
                          >
                            ${{ row.BALANCEDUE.toFixed(2) }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  xs="12"
                  sm="12"
                  class="pa-5"
                  style="
                    text-align: center;
                    margin-top: 10px;
                    font-weight: bold;
                  "
                >
                  Total Payment by ACH Debit: ${{ totalPayment.toFixed(2) }}
                </v-col>
              </v-row>

              <v-row class="pa-2 ma-0">
                <v-card class="ma-0" elevation="0">
                  <v-row>
                    <v-col cols="12" md="12" xs="12" sm="12" class="pa-5">
                      We only permit one (1) bank account to be registered for
                      payments. If you prefer to use a different bank account
                      than the one shown below, click the
                      <strong>View Bank Account</strong>
                      button and complete the required information. If you want
                      to change back to the original bank account, please login
                      to
                      <a
                        :href="$store.state.myenroll_url"
                        target="_blank"
                        style="color: black; text-decoration: underline"
                      >
                        {{ $store.state.url_name }}
                      </a>
                      and select the
                      <strong>Manage ACH Preferences</strong>
                      Quick Link button.
                    </v-col>
                    <v-col cols="12" md="12" xs="12" sm="12" class="pa-5">
                      <v-btn
                        class="mt-3"
                        @click="change_bank_account"
                        style="background-color: lightgrey; width: 100%"
                      >
                        <span style="text-align: center; font-weight: bold"
                          >View Bank Account</span
                        >

                        <!-- Icon on the Right -->
                        <v-icon
                          style="
                            margin-left: auto;
                            position: absolute;
                            right: 16px;
                          "
                        >
                          {{ "mdi-chevron-up" }}
                        </v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="12" xs="12" sm="12" class="pa-5 mt-0">
                      <BankDetails v-if="showbankpage" ref="bank_childRef" />
                    </v-col>
                  </v-row>
                </v-card>
              </v-row>
              <v-row
                style="
                  margin-bottom: 10px;
                  margin-top: 10px;
                  justify-content: center;
                  gap: 20px;
                "
              >
                <v-btn
                  variant="elevated"
                  color="info"
                  class="white--text rounded"
                  @click="cancel"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="submit"
                  variant="elevated"
                  color="primary"
                  class="white--text rounded"
                  >Save Your Payment <br />
                  & Bank Information</v-btn
                >
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="showDialog" max-width="1000px">
      <v-toolbar
        class="text-h5 font-weight-bold black--text grey lighten-2 pa-3"
        height="45px"
      >
        Instructions
        <v-spacer></v-spacer>
        <v-btn
          icon
          variant="elevated"
          color="black"
          size="x-small"
          @click="showDialog = false"
          aria-label="Close"
        >
          <v-icon color="white" size="18">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <InstructionsPage @close="showDialog = false" />
    </v-dialog>

    <!-- Copied from bank page -->

    <v-dialog v-model="cancelDialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6"
          >Are you sure you want to Cancel?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" variant="text" text @click="cancelDialog = false"
            >No</v-btn
          >
          <v-btn color="green" variant="text" @click="handleCancel">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDialogSubmit" max-width="400px">
      <v-card>
        <v-card-title class="text-h6"
          >Are you sure you want to Submit?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" variant="text" @click="confirmDialogSubmit = false"
            >No</v-btn
          >
          <v-btn color="green" variant="text" @click="handleConfirmSubmit"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="emailDialogue" max-width="400">
      <v-card>
        <v-card-title class="headline">Saved sucessfully!</v-card-title>

        <v-card-text
          >If you provided an email address, you will receive a confirmation of
          this payment, shortly.</v-card-text
        >

        <v-card-actions>
          <v-btn
            variant="elevated"
            color="primary"
            @click="
              () => {
                emailDialogue = false;
                closeDialog();
              }
            "
            style="margin-left: 30px"
            >Close</v-btn
          >
          <v-btn
            variant="elevated"
            color="success"
            class="success"
            style="margin-left: 30px"
            @click="
              () => {
                emailDialogue = false;
                redirecthome();
              }
            "
          >
            Redirect to MyEnroll
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lock_value_dialog" max-width="650px">
      <v-card>
        <v-card-title class="text-h6 red--text">
          Account is locked for processing, please try again in 1-2
          minutes.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="text"
            color="red"
            text
            @click="lock_value_dialog = false"
            >ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="noPaymentDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">Payment Selection Required</v-card-title>
        <v-card-text>
          Please select at least one payment to submit the details.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            color="primary"
            @click="noPaymentDialog = false"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorDialog" max-width="700px">
      <v-card>
        <v-card-title
          class="headline text-red-500"
          color="red"
          style="color: red"
          >Error: Missing Information</v-card-title
        >
        <v-card-text>
          <p>Oops! We need more information to proceed with your enrollment.</p>
          <ul>
            <li>
              <strong>ACH Setup Required:</strong>
              Please provide the necessary ACH information to move to the next
              step.
            </li>
            <li>
              <strong>Updating Existing Information:</strong>
              If you are editing existing ACH bank account information, please
              re-enter the updated details:
              <ul>
                <li>
                  <strong>Account Number:</strong>
                  Enter the account number, as you’ve updated the details or
                  wish to resubmit the form.
                </li>
                <li>
                  <strong>ABA Number:</strong>
                  Enter the ABA number, as you’ve updated the details or wish to
                  resubmit the form.
                </li>
                <li>
                  <strong>Bank Name:</strong>
                  Enter the Bank Name.
                </li>
                <li>
                  <strong>Type of Account:</strong>
                  Please select the type of bank account.
                </li>
                <li>
                  <strong>Terms and Conditions:</strong>
                  Please check the box to agree to the terms and conditions.
                </li>
                <li>
                  <strong>Signature:</strong>
                  Ensure you add your signature to complete the submission.
                </li>
              </ul>
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-btn variant="elevated" color="primary" @click="errorDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* global html2canvas */

import axios from "axios";
import InstructionsPage from "./InstructionsPage.vue";
import BankDetails from "./BankDetails.vue";

export default {
  data() {
    return {
      TABLEDATA: [],
      InstructionsPageDialog: false,
      showbankpage: true,
      showDialog: false,
      errorDialog: false,
      emailDialogue: false,
      confirmDialogSubmit: false,
      confirmDialog: false,
      cancelDialog: false,
      noPaymentDialog: false,
      employee_number: "",
      loading: false,
      save_loading: false,
      showpaymenterror_msg: false,
      exit_table_Data: [],
      lock_value_dialog: false,
      headers: [
        { title: "Select to Pay", value: "select" },
        { title: "Billing Period", value: "BILLING_PERIOD" },
        { title: "Due Date", value: "DUEDATE" },
        { title: "Amount Billed", value: "AMOUNT_BILLED" },
        { title: "Prior Paid", value: "PRIORPAID" },
        { title: "Balance Due", value: "BALANCEDUE" },
      ],
    };
  },
  components: { InstructionsPage, BankDetails },
  computed: {
    methodUrl() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },

    totalPayment() {
      return this.TABLEDATA.reduce((sum, row) => {
        if (
          (row.PENDING_ACH_PAY_REFID === null ||
            row.PENDING_ACH_PAY_REFID === "") &&
          row.SELECTED_FOR_PAYMENT == 1
        ) {
          return sum + row.BALANCEDUE;
        }
        return sum;
      }, 0);
    },
  },
  mounted() {
    this.employee_number = this.$store.state.employee_number;
    this.initializeData();
  },
  methods: {
    async initializeData() {
      this.loading = false;
      try {
        await this.get_ee_bill_data();
      } catch (error) {
        console.log("Error initializing data:", error);
      }
    },

    handleCancel() {
      this.cancelDialog = false;
      this.unlock_ee_record();
      const href = location.href.toLowerCase();
      if (href.indexOf("test") > -1) {
        window.location =
          "https://www.bastest.com/web_projects/MainHomePage/Login.aspx";
      } else {
        window.location = this.$store.state.myenroll_url;
      }
    },

    cancel() {
      this.cancelDialog = true;
    },

    change_bank_account() {
      //this.$router.push({ name: "BankDetails" });
      this.showbankpage = !this.showbankpage;
    },
    async get_ee_bill_data() {
      this.showpaymenterror_msg = false;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/get_ee_bill_data`,
          { employeeNumber: this.employee_number },
        )
        .then((r) => {
          const res = JSON.parse(r.data.d);

          if (res.length > 0) {
            this.TABLEDATA = res.map((item) => ({
              ...item, // Copy all existing properties
              SELECTED_FOR_PAYMENT: Number(item.SELECTED_FOR_PAYMENT),
              BILLING_PERIOD: item.BILLING_PERIOD,

              DUEDATE: item.DUEDATE,
            }));
            this.exist_table_Data = res;
            var check_data = this.TABLEDATA.filter(
              (row) =>
                row.PENDING_ACH_PAY_REFID == null ||
                row.PENDING_ACH_PAY_REFID == "",
            );
            if (check_data.length == 0) {
              this.showpaymenterror_msg = false;
            }
          } else {
            this.showpaymenterror_msg = false;
          }
          this.loading = false;
          //console.log("Processed tableData:", this.TABLEDATA);
        })
        .catch((e) => {
          this.loading = false;
          console.error("Error fetching data:", e);
        });
    },

    redirecthome() {
      // window.location = this.$store.state.myenroll_url;
      const href = location.href.toLowerCase();
      if (href.indexOf("test") > -1) {
        window.location =
          "https://www.bastest.com/web_projects/MainHomePage/Login.aspx";
      } else {
        window.location = this.$store.state.myenroll_url;
      }
    },
    unlock_ee_record() {
      var self = this;
      self.loading = true;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/unlock_ee_record`,
          {
            employeeNumber: this.employee_number,
          },
        )

        .catch(function (e) {
          self.loading = false;
          console.log("error -unlock_ee_record" + e);
        });
    },
    async save_ach_data() {
      this.loading = true;
      this.save_loading = true;

      try {
        const response = await axios.post(
          `${this.methodUrl}/make_payment/Webservice.asmx/save_ach_data`,
          {
            bank_account_number: this.$store.state.bank_account_number,
            Employee_Number: this.$store.state.employee_number,
            bank_aba_number: this.$store.state.abaNumber,
            bank_account_type: this.$store.state.bank_account_type,
            bank_name: this.$store.state.bankName,
          },
        );

        const result = response.data.d;

        if (
          result &&
          this.$refs.bank_childRef &&
          typeof this.$refs.bank_childRef.get_ee_ach_data === "function"
        ) {
          await this.$refs.bank_childRef.get_ee_ach_data(); // Wait until ACH data is refreshed
          await this.$nextTick(); // Wait for DOM updates, if needed
          await this.captureAndUpload(result); // Then capture & upload
        } else {
          // alert("Missing result");
          console.warn("Missing result or invalid child reference.");
        }
      } catch (error) {
        console.error("Error in save_ach_data:", error);
        // alert("Error in save_ach_data:", error);
      } finally {
        this.loading = false;
        this.save_loading = false;
      }
    },

    //save_ach_data(string bank_account_number,int Employee_Number,int bank_aba_number_,int bank_account_type_,string bank_name_)
    save_ach_data_old() {
      var self = this;
      self.loading = true;
      axios
        .post(`${this.methodUrl}/make_payment/Webservice.asmx/save_ach_data`, {
          bank_account_number: self.$store.state.bank_account_number,
          Employee_Number: self.$store.state.employee_number,
          bank_aba_number: self.$store.state.abaNumber,
          bank_account_type: self.$store.state.bank_account_type,
          bank_name: self.$store.state.bankName,
        })
        .then((r) => {
          var result = r.data.d;
          //console.log("Result", result);
          if (result != "") {
            self.$refs.bank_childRef
              .get_ee_ach_data()
              .then(() => {
                setTimeout(() => {
                  self.captureAndUpload(result);
                }, 60);
              })
              .catch((e) => {
                self.loading = false;
                console.log("Error during get_DDInfo or capture: ", e);
              });
          }
        })
        .catch(function (e) {
          self.save_loading = false;
          self.loading = false;
          console.log("error - save_ach_data" + e);
        });
    },

    closeDialog() {
      this.get_ee_bill_data();
      this.$refs.bank_childRef.get_ee_ach_data();
    },
    async captureAndUpload(record_id_) {
      const self = this;

      try {
        // Wait for DOM to render completely
        await this.$nextTick();
        await new Promise((r) => setTimeout(r, 500)); // ensure styles applied

        const element = document.getElementById("form-container");

        if (!element) {
          throw new Error("Form container not found");
        }

        // iOS / mobile memory safeguard
        if (element.scrollHeight > 15000) {
          throw new Error("Content too large for PDF export on mobile");
        }

        // Temporarily expand container for full capture
        const originalHeight = element.style.height;
        element.style.height = element.scrollHeight + "px";

        // Capture HTML to canvas
        const canvas = await html2canvas(element, {
          scale: window.devicePixelRatio > 2 ? 1.5 : 2,
          useCORS: true,
          scrollY: -window.scrollY,
          windowWidth: document.body.scrollWidth,
          windowHeight: element.scrollHeight,
          onclone: (doc) => {
            doc.querySelectorAll("*").forEach((el) => {
              const style = getComputedStyle(el);
              if (style.color.includes("color(")) el.style.color = "#000"; // fix iOS color issue
            });
          },
        });

        // Restore original height
        element.style.height = originalHeight;

        // Convert canvas to image
        const imgData = canvas.toDataURL("image/jpeg", 0.98);

        // Initialize PDF
        const pdf = new window.jsPDF("p", "pt", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Add image to PDF with pagination
        let position = 0;
        while (position < pdfHeight - 1) {
          pdf.addImage(imgData, "JPEG", 0, -position, pdfWidth, pdfHeight);
          if (position + pageHeight < pdfHeight) pdf.addPage();
          position += pageHeight;
        }

        // Export PDF as blob
        const pdfBlob = pdf.output("blob");

        // Prepare FormData for upload
        const data = new FormData();
        data.append("employee_number", this.$store.state.employee_number);
        data.append("record_id_", record_id_);
        data.append("pdfBlob", pdfBlob, "capture.pdf");

        // POST to server
        const URL = self.methodUrl + "/make_payment/ACH_FIleHandler.ashx";
        await axios.post(URL, data);

        // Success UI updates
        this.unlock_ee_record();
        this.emailDialogue = true;
        this.save_loading = false;
        this.loading = false;
      } catch (error) {
        // Error handling
        this.save_loading = false;
        this.loading = false;
        this.emailDialogue = false;
        console.error("Error capturing or uploading PDF:", error);
        console.log(
          "Error capturing or uploading PDF: " + (error?.message || error),
        );
      }
    },

    updateSelection(index) {
      if (this.TABLEDATA[index].SELECTED_FOR_PAYMENT === 1) {
        for (let i = 0; i <= index; i++) {
          this.TABLEDATA[i].SELECTED_FOR_PAYMENT = 1;
        }
      } else {
        for (let i = index; i < this.TABLEDATA.length; i++) {
          this.TABLEDATA[i].SELECTED_FOR_PAYMENT = 0;
        }
      }
    },
    submitForm() {
      this.loading = true;
      this.save_ee_bill_data();
      setTimeout(() => {
        this.uncheck_bill_data();
      }, 50);

      if (this.$store.state.selectedOption == "2") this.save_ach_data();
      else {
        this.captureAndUpload(0);
      }
    },
    save_ee_bill_data() {
      const filteredRows = this.TABLEDATA.filter(
        (row) =>
          (row.PENDING_ACH_PAY_REFID === null ||
            row.PENDING_ACH_PAY_REFID === "") &&
          row.SELECTED_FOR_PAYMENT == 1,
      );
      // Loop through the filtered rows and call the axios method
      filteredRows.forEach((row) => {
        axios
          .post(
            `${this.methodUrl}/make_payment/Webservice.asmx/save_ee_bill_data`,
            {
              employee_number_: row.EMPLOYEE_NUMBER,
              billing_type_: row.BILLING_TYPE,
              payment_refid_: row.PAYMENT_REFID,
              selected_option: row.SELECTED_FOR_PAYMENT,
            },
          )
          // .then((response) => {
          //   console.log(`Row saved successfully:`, response.data);
          // })
          .catch((error) => {
            console.error(`Error saving row:`, error);
            this.save_loading = false;
            this.loading = false;
          });
      });
    },

    uncheck_bill_data() {
      const oldjson = this.exist_table_Data.filter(
        (item) => item.SELECTED_FOR_PAYMENT == 1 && !item.PENDING_ACH_PAY_REFID,
      ); // Previous JSON

      const newtabledata = this.TABLEDATA;
      const changedRecords = oldjson.filter((oldItem) => {
        const newItem = newtabledata.find(
          (tableItem) => tableItem.PAYMENT_REFID === oldItem.PAYMENT_REFID,
        );
        return newItem?.SELECTED_FOR_PAYMENT === 0;
      });
      //console.log("Changed Records:", JSON.stringify(changedRecords, null, 2));

      // Loop through the filtered rows and call the axios method
      changedRecords.forEach((row) => {
        axios
          .post(
            `${this.methodUrl}/make_payment/Webservice.asmx/uncheck_bill_data`,
            {
              employee_number_: row.EMPLOYEE_NUMBER,
              billing_type_: row.BILLING_TYPE,
              payment_refid_: row.PAYMENT_REFID,
            },
          )
          .then((response) => {
            console.log(`Row saved successfully:`, response.data);
          })
          .catch((error) => {
            console.error(`Error saving row:`, error);
            this.save_loading = false;
            this.loading = false;
          });
      });
    },

    //copied from bank
    handleConfirm() {
      this.confirmDialog = false;
      this.cancel();
    },

    handleConfirmSubmit() {
      this.confirmDialogSubmit = false;
      this.emailDialogue = true;
      this.submitForm();
    },

    async isFormValid() {
      var self = this;
      if (self.$store.state.selectedOption == "1") {
        return (
          this.checkboxrules(self.$store.state.checkbox) === true &&
          self.$store.state.sign_value.length > 0
        );
      } else {
        return (
          this.validAccountNumber(self.$store.state.bank_account_number) ===
            true &&
          this.namerules(this.bank_account_type) === true &&
          this.ValidAbaNumber(self.$store.state.abaNumber) === true &&
          this.validBankName(self.$store.state.bankName) === true &&
          this.checkboxrules(self.$store.state.bank_account_type) === true &&
          self.$store.state.bank_account_number != null &&
          self.$store.state.bank_account_number.indexOf("x") > -1 === false &&
          self.$store.state.bank_account_number.indexOf("*") > -1 === false &&
          self.$store.state.abaNumber != null &&
          self.$store.state.abaNumber.indexOf("x") > -1 === false &&
          self.$store.state.abaNumber.indexOf("*") > -1 === false &&
          self.$store.state.sign_value.length > 0
        );
      }
    },

    async callbankchildvalidation() {
      var self = this;
      if (
        self.$refs.bank_childRef &&
        typeof self.$refs.bank_childRef.isvalid === "function"
      ) {
        self.$refs.bank_childRef.isvalid();
      }
    },
    check_lock_value() {
      //console.log("hello");
      var self = this;

      self.lock_value_dialog = false;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/check_lock_value`,
          {
            employeeNumber: self.$store.state.employee_number,
          },
        )
        .then((r) => {
          const res = r.data.d;
          if (res == "2" || res == "3") {
            self.lock_value_dialog = true;
          } else {
            self.confirmDialogSubmit = true;
          }
        })
        .catch(function (e) {
          self.loading = false;
          console.log("error -check_lock_value" + e);
        });
    },

    async submit() {
      if (this.totalPayment === 0) {
        this.noPaymentDialog = true;
        return;
      }
      try {
        const valid = await this.isFormValid();
        if (valid) {
          this.check_lock_value();
        } else {
          await this.callbankchildvalidation();
          this.errorDialog = true;
        }
      } catch (e) {
        console.error("Validation error", e);
        this.errorDialog = true;
      }
    },
    validAccountNumber(value) {
      const val = value ? String(value) : "";

      if (val === "") {
        return "Enter the Account Number";
      }

      // Require digits only (no spaces or other chars) and enforce reasonable length
      const digits = val.replace(/\s+/g, "");
      if (!/^[0-9]+$/.test(digits)) {
        console.log("Invalid characters in account number");
        return "Account number must contain only digits";
      }

      return true;
    },

    namerules(value) {
      if (value == "") {
        return "Select the type of account";
      } else {
        return true;
      }
    },
    ValidAbaNumber(value) {
      const val = value ? String(value).trim() : "";

      if (val === "") {
        return "Enter the ABA Number";
      }

      const digits = val.replace(/\s+/g, "");
      if (!/^[0-9]{9}$/.test(digits)) {
        return "Enter a valid 9-digit ABA number";
      }

      return true;
    },

    validBankName(value) {
      if (value == "") {
        return "Enter the Bank Name";
      } else {
        return true;
      }
    },
    checkboxrules(value) {
      if (value == "") {
        return "";
      } else {
        return true;
      }
    },
    formatDate(date) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const year = d.getFullYear();
      return `${month}/${day}/${year}`;
    },
  },
};
</script>
<style>
.table-scroll-both {
  width: 100%;
  max-height: 850px; /* adjust to desired visible height */
  overflow-x: auto; /* explicitly allow horizontal scroll */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* keep row sizing tight */
.full-width-table > table {
  width: max-content; /* allow table intrinsic width */
  min-width: 980px;
  table-layout: fixed;
  border-collapse: collapse;
}

.full-width-table th,
.full-width-table td {
  min-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none; /* remove all cell borders */
  border-bottom: 1px solid #ddd; /* only show bottom border */
}
/* Add styles to visually indicate a locked row */
.locked-row {
  background-color: #f5f5f5; /* Light gray background */
  pointer-events: none; /* Prevent interactions */
  opacity: 0.6; /* Reduce visibility */
}

.pointer-cursor {
  cursor: pointer; /* Makes the cursor a hand symbol */
}
.pdf-safe {
  background-image: none !important;
  color: #000 !important;
  background-color: #fff !important;
  /* transform: translateZ(0);
  -webkit-transform: translateZ(0);
  will-change: transform; */
}
.bas-desc {
  font-size: 15px;
  background-color: #e1ecf9 !important;
  color: #185fa5;
  text-align: left;
  line-height: 1.6;
  margin: 0 0 18px;
}
</style>
